import React from 'react';
import { motion } from 'framer-motion';
import { landingSteps } from '../../data/landingSteps';
import { NodeNetwork } from '../NodeNetwork';
import { Reveal } from '../Reveal';
export function LandingSteps() {
  return <section className="mx-auto max-w-6xl px-6 py-24" data-id="element-144" data-mp="2jcz6ezf1uweo">
      <Reveal className="max-w-2xl" data-id="element-145" data-mp="2edcuctayjm7g">
        <h2 className="font-display text-4xl font-semibold tracking-tight md:text-5xl" data-id="element-146" data-mp="2ecbiwnq14xp7">One network. Two sides.</h2>
        <p className="mt-4 text-lg text-muted" data-id="element-147" data-mp="2sbb8bxld9gmf">Companies need things done in places they can't be. Locals are already there. We connect them.</p>
      </Reveal>

      <div className="mt-14 grid items-center gap-12 lg:grid-cols-[1.1fr_1fr]" data-id="element-148" data-mp="3237595bpv0p2">
        <Reveal data-id="element-149" data-mp="2x3kwp96u28ml">
          <NodeNetwork hubLabel="localtask" data-id="element-150" data-mp="2x32r3lya6i20" />
        </Reveal>

        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-1" data-id="element-151" data-mp="2x5x976ttnqs9">
          {landingSteps.map(group => <div key={group.title} data-id="element-152" data-mp="371qvvj1990nr">
              <h3 className="font-mono text-sm text-accent" data-id="element-153" data-mp="372tktlf0ot11">{group.title.toLowerCase()}</h3>
              <ol className="mt-4 space-y-4" data-id="element-154" data-mp="jonqmdlpot19">
                {group.steps.map((step, i) => <motion.li key={step} initial={{
              opacity: 0,
              x: -8
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1],
              delay: i * 0.05
            }} className="flex gap-4" data-id="element-155" data-mp="om72x7yumvqk" data-mpi={i}>
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-line bg-surface font-mono text-xs font-medium" data-id="element-156" data-mp="17lb6w2bj9zbd">
                      {i + 1}
                    </span>
                    <span className="pt-0.5 leading-relaxed" data-id="element-157" data-mp="1gd3g69otn2ed">{step}</span>
                  </motion.li>)}
              </ol>
            </div>)}
        </div>
      </div>
    </section>;
}